import React from 'react'
import { PropTypes } from 'prop-types'
import { hideModal } from '../../state/actions/stepActions'
import { connect } from 'react-redux'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Modal = props => {
  const handleClick = (/*e*/) => {
    const { dispatch } = props
    dispatch(hideModal())
  }

  return (
    <div
      {...css(
        props.styles.modal,
        !!props.hidden && props.styles['modal--hidden']
      )}
    >
      <div {...css(props.styles.bg)} />

      <div
        {...css(props.styles.closeBtn)}
        onClick={event => handleClick(event)}
      />

      <div {...css(props.styles.wrapper)}>
        <div {...css(props.styles.content)}>{props.children}</div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  children: PropTypes.node,
  content: PropTypes.string,
  hidden: PropTypes.bool
}

const mapStateToProps = state => {
  const { step } = state
  return { step }
}

export default connect(mapStateToProps)(withStyles(Styles)(Modal))



// WEBPACK FOOTER //
// ./components/modal/index.js